// Number formatting helpers shared across components. Centralised so
// "$104,832" formats identically in the My Stack tile and the Goals tile.

const USD_FULL = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
});

const USD_FRACTIONAL = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const BTC_FORMAT = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 8,
});

export function formatUsd(value, { fractional = false } = {}) {
  if (!Number.isFinite(value)) return '—';
  return (fractional ? USD_FRACTIONAL : USD_FULL).format(value);
}

export function formatBtc(value) {
  if (!Number.isFinite(value)) return '—';
  return `${BTC_FORMAT.format(value)} BTC`;
}

export function formatPct(value, { signed = false, decimals = 2 } = {}) {
  if (!Number.isFinite(value)) return '—';
  const sign = signed && value > 0 ? '+' : '';
  return `${sign}${value.toFixed(decimals)}%`;
}
